//获取权限信息
import {contractApi} from "@/axios";
//获取权限信息
export function getPermissionPage(params,data){
    return contractApi({
        url:'/trade-permission-allocation/page',
        method:'post',
        data:data,
        params:params
    })
}
//添加权限信息
export function addPermission(data){
    return contractApi({
        url:'/trade-permission-allocation',
        method:'post',
        data:data
    })
}
//删除权限信息
export function deletePermission(params){
    return contractApi({
        url:'/trade-permission-allocation',
        method:'delete',
        params:params
    })
}
//修改权限信息
export function editPermission(data){
    return contractApi({
        url:'/trade-permission-allocation',
        method:'put',
        data: data
    })
}